import React from "react";
import { Group, Rect } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { updateRoofDetails } from "../../../../Features/quantityInfo";

export default function CustomizeImage({
  image,
  isSelected,
  onSelect,
  images,
  drag,
  check,
}) {
  const dispatch = useDispatch();
  const quantityInfo = useSelector((state) => state.quantity);
  const rowFrame = image.rowFrame;
  const colFrame = image.colFrame;
  const width = (image.width - (colFrame - 1) * image.moduleSpacing) / colFrame;
  const height =
    (image.height - (rowFrame - 1) * image.moduleSpacing) / rowFrame;

  const handleClick = () => {
    onSelect(image);
  };

  const handleDragEnd = (e) => {
    const updatedImage = {
      ...image,
      x: e.target.x(),
      y: e.target.y(),
    };

    const newImages = [...images];
    const indexToUpdate = newImages.findIndex(
      (img) => img.id === updatedImage.id
    );

    newImages[indexToUpdate] = updatedImage;

    dispatch(
      updateRoofDetails({
        index: quantityInfo.roofNo,
        fields: {
          images: newImages,
        },
      })
    );

    onSelect(updatedImage);
  };

  return (
    <Group
      x={image.x}
      y={image.y}
      rotation={image?.angleDegree ? image.angleDegree : 0}
      draggable={check ? !drag : false}
      onClick={handleClick}
      onTap={handleClick}
      onDragEnd={handleDragEnd}
    >
      {Array.from({ length: rowFrame }).map((_, rowIndex) =>
        Array.from({ length: colFrame }).map((_, colIndex) => (
          <Rect
            key={`${rowIndex}-${colIndex}`}
            x={colIndex * (width + image.moduleSpacing)}
            y={rowIndex * (height + image.moduleSpacing)}
            width={width}
            height={height}
            fill={isSelected ? "seagreen" : "#27326A"}
          />
        ))
      )}
    </Group>
  );
}
